import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import { createStyles, makeStyles, Theme } from '@material-ui/core';

import React from 'react';

import { baseTheme } from '../../../theme';

const useStyles = makeStyles((theme: Theme) =>
    createStyles({
      root: {
        paddingTop: theme.spacing(2),
        paddingRight: theme.spacing(2),
        paddingBottom: theme.spacing(2),
        paddingLeft: theme.spacing(2),
        color: theme.palette.primary.main,
        textAlign: 'center',
      },
      copySpacer: {
        paddingTop: theme.spacing(2),
        paddingBottom: theme.spacing(2),
        color: theme.palette.text.primary,
      },
    }),
);

export default function GroupListEmpty(props:any) {
  const classes = useStyles(baseTheme);
  return (
    <Grid item container direction="column" className={classes.root}>
        <Grid item container direction="column">
            <Typography className={classes.copySpacer}>
                To go live with a post, you must first create a closed or public group.
            </Typography>
        </Grid>
    </Grid>
  );
}
